import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";
import { PageHeader } from "@/components/site/PageHeader";
import { Reveal, Eyebrow } from "@/components/site/Reveal";
import { QuoteForm } from "@/components/site/QuoteForm";
import { CONTACT } from "@/data/content";

export default function Contact() {
  useSeo({
    title: "Contact | Request a Quote | Lighthouse Home Services",
    description:
      "Request a free quote from Lighthouse Home Services, a family-owned HVAC company in Oxford, MA serving homeowners throughout Massachusetts.",
  });

  const details = [
    { icon: Phone, label: "Call us", value: CONTACT.phone, href: CONTACT.phoneHref },
    { icon: Mail, label: "Email us", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: MapPin, label: "Based in", value: CONTACT.address },
    { icon: Clock, label: "Hours", value: "Mon–Fri · 8am–5pm" },
  ];

  return (
    <div>
      <PageHeader
        eyebrow="Contact"
        title={<>Let's talk comfort.</>}
      />

      <section className="mx-auto max-w-7xl px-5 md:px-8 pb-24 md:pb-32">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal><Eyebrow>Get in Touch</Eyebrow></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-serif text-3xl md:text-4xl leading-tight text-navy">
                We'd love to hear from you.
              </h2>
            </Reveal>
            <div className="mt-10 space-y-5">
              {details.map((d) => {
                const inner = (
                  <div className="flex items-center gap-4 rounded-2xl bg-sand p-5 transition-transform duration-300 hover:-translate-y-0.5">
                    <div className="grid place-items-center h-12 w-12 rounded-full bg-navy text-gold shrink-0">
                      <d.icon className="h-5 w-5" />
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground">{d.label}</p>
                      <p className="font-serif text-xl text-navy">{d.value}</p>
                    </div>
                  </div>
                );
                return (
                  <Reveal key={d.label}>
                    {d.href ? <a href={d.href} data-testid={`contact-${d.label.split(" ")[0].toLowerCase()}`}>{inner}</a> : inner}
                  </Reveal>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <QuoteForm />
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
